<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Get Child Event</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Child</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list"
                            item-text="learner" item-value="uid" label="Child" outlined persistent-hint
                            hint="Please Select Child" @change="fetchdataforchild()" />
                    </v-col>

                </v-row>
            </v-card>

            <v-card class="box" v-if="show_child_details_card">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Child Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <p><b>Student Name</b></p>
                        <v-text-field outlined dense type="text" v-model="child_details.name" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><b>Standard</b></p>
                        <v-text-field outlined dense type="text" v-model="child_details.standard"
                            readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><b>Division</b></p>
                        <v-text-field outlined dense type="text" v-model="child_details.division"
                            readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><b>Roll No</b></p>
                        <v-text-field outlined dense type="text" v-model="child_details.roll_no"
                            readonly></v-text-field>
                    </v-col>
                    <!-- <v-col col="12" sm="2" class="pt-5 mt-6 ml-5">
                        <v-btn color="warning" @click="FetchEvent()">Fetch</v-btn>
                    </v-col> -->
                </v-row>
            </v-card>
            <v-card class="box" v-if="events.length > 0">
                <div>
                    <v-sheet tile color="grey lighten-3">
                        <v-row dense>
                            <v-col cols="12" sm="1" md="1">
                                <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="2" md="1" class="text-center">
                                <v-menu>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on"
                                            class="month-dropDown">
                                            <span>{{ typeToLabel[type] }}</span>
                                            <v-icon right>mdi-menu-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item @click="type = 'month'">
                                            <v-list-item-title>Month</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="type = 'week'">
                                            <v-list-item-title>Week</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="type = 'day'">
                                            <v-list-item-title>Day</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="1" md="1"></v-col>
                            <v-col cols="12" sm="3" md="5" class="text-center">
                                <h1 class="curr-month">{{ curr_month || title }}</h1>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" align="right">
                                <v-select v-model="weekday" :items="weekdays" dense outlined hide-details
                                    label="weekdays" class="ma-2"></v-select>
                            </v-col>
                            <v-col cols="12" sm="2" md="1" align="right">
                                <v-chip class="ma-2" color="brand onBrand--text" @click="setToday">Go To Today</v-chip>
                            </v-col>
                            <v-col cols="12" sm="1" md="1" align="right">
                                <v-btn icon class="ma-2" @click="$refs.calendar.next()">
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-sheet>
                    <v-sheet height="520">
                        <v-calendar ref="calendar" v-model="value" :weekdays="weekday" color="primary" :type="type"
                            :events="events" :event-overlap-mode="column" :event-overlap-threshold="1000"
                            :max-events="1000" :event-color="getEventColor" @click:event="showEvent"
                            @click:more="viewDay" @click:day="getdata">
                        </v-calendar>
                    </v-sheet>
                    <v-dialog v-model="dialog" width="500">
                        <v-card>
                            <v-card-title class="headline">{{ tempevents.name }}</v-card-title>
                            <v-card-text>
                                <div class="headline mb-2">Description: {{ tempevents.description }}</div>
                                <v-chip class="mr-2" color="lightgreen" text-color="white">
                                    <v-icon left>mdi-brightness-5</v-icon>
                                    Class: {{ tempevents.std }}
                                </v-chip>
                                <div>Start: {{ tempevents.start }}</div>
                                <div>End: {{ tempevents.end }}</div>
                                <div v-if="tempevents.attachment && tempevents.attachment.length > 0">
                                    <div class="mt-2">Attachments:</div>
                                    <div v-for="(attachment, index) in tempevents.attachment" :key="index"
                                        style="margin-bottom: 8px;">
                                        {{ index + 1 }}. <a :href="basepath + attachment.link"
                                            target="_blank">Attachment</a>
                                    </div>
                                </div>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="dialog = false">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import child_calendar_event from "./childCalenderEvent.vue";

export default {
    components: {
        "child-calendar-event": child_calendar_event,
    },
    data: () => ({
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        ay_list: [],
        ay: "",
        child_list: [],
        child: "",
        dialog: false,
        value: "",
        basepath: null,
        type: "month",
        typeToLabel: {
            month: "Month",
            week: "Week",
            day: "Day",
        },
        eventColors: {},
        weekday: [1, 2, 3, 4, 5, 6, 0], // Default weekdays set to Mon - Sun
        weekdays: [
            { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
            { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] }, // Default selection
            { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
        ],
        events: [],
        tempevents: { name: "", description: "", std: "", grno: "", start: "", end: "", attachment: [] },
        title: "",
        curr_month: null,
        show_child_details_card: false,

        child_details: { name: "", stamdard: "", division: "", roll_no: "" },

    }),
    updated() {
        this.$nextTick().then(() => {
            if (this.$refs.calendar && this.$refs.calendar.value != "") {
                let date = this.$refs.calendar.value;
                var no = date.split("-");
                this.curr_month = this.months[parseInt(no[1])];
            }
        });
    },
    methods: {
        showEvent({ event }) {
            this.tempevents = { ...event };
            this.dialog = true;
        },
        viewDay({ date }) {
            this.value = date;
            this.type = "day";
        },
        setToday() {
            this.value = "";
            this.curr_month = null;
        },
        // Generate a fixed color based on the event name or ID
        generateColorFromName(name) {
            let hash = 0;
            for (let i = 0; i < name.length; i++) {
                hash = name.charCodeAt(i) + ((hash << 5) - hash);
            }
            const color = '#' + ((hash & 0x00FFFFFF) | 0x1000000).toString(16).substring(1).toUpperCase();
            return color;
        },
        getEventColor(event) {
            // Generate a fixed color based on the event name
            return this.generateColorFromName(event.name);
        },
        dateTime() {
            let dt = this.formatDate(this.datetime, true);
            const formData = {
                datetime: dt,
            };
            axios
                .post("tryNError/dateTime", formData)
                .then((res) => {
                    if (res.data.msg == "200") {
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        getdata({ day }) {
        },
        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a;
        },
        formatDate(a, withTime) {
            return withTime ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}` : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
        },
        getMonthYYYYMMDD(date) {
            var num_month = date.split("-");
            var months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            return months[parseInt(num_month[1])];
        },
        fetchdataforchild() {
            const data = {
                ay: this.ay,
                child: this.child,
            };
            localStorage.setItem("ay", JSON.stringify(this.ay));
            localStorage.setItem("child", JSON.stringify(this.child));

            this.show_child_details_card = false;

            this.overlay = true;
            axios
                .post("/communication/getCalendarforEvent", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        if (res.data.eventInfoNew.length !== 0) {
                            this.events = res.data.eventInfoNew.map(event => {
                                return {
                                    name: event.name,
                                    start: event.start,
                                    end: event.to_date,
                                    color: this.getEventColor(event),
                                    description: event.description,
                                    std: event.std,
                                    grno: event.grno,
                                    attachment: event.attachment
                                };
                            });
                        }
                        if (this.$refs.calendar && this.$refs.calendar.start) {
                            this.title = this.getMonthYYYYMMDD(this.$refs.calendar.start);
                        }
                        this.child_details.name = res.data.learner;
                        this.child_details.standard = res.data.standard;
                        this.child_details.division = res.data.division;
                        this.child_details.roll_no = res.data.roll_no;
                        this.show_child_details_card = true;


                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    //  this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },
        onLoad() {
            axios
                .post("ParentTransport/applyTransportFacility")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                        this.child_list = res.data.learner_list;
                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

    },
    mounted() {
        this.basepath = localStorage.getItem("awspath");
        this.onLoad();
        this.show_child_details_card = false;
    },
    watch: {},
};
</script>
<style scoped></style>
